import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth";

export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Caricamento...</div>;
  }
  if (!user) return <Navigate to="/accedi" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
